import { Application } from '~/types/Application';
import { getStagePayload } from './getStagePayload';

export const isReadOnly = (application: Application | undefined): boolean => {
  const stagePayload = getStagePayload.wizard(application);
  const isReadOnlyApplication = application?.readOnly || false;
  const isReadOnlyStep = stagePayload?.activeStep.state === 'READ_ONLY';
  return isReadOnlyApplication || isReadOnlyStep;
};
